import type { UserEvent } from '../types';

export const findCurrentUserEvent = (currentEventId: number) => (userEvents: UserEvent[]) =>
  userEvents.find((userEvent) => userEvent?.event?.id === currentEventId);
